import * as types from './answer.types';
import * as constants from './answer.constants';
import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

export const storeAnswer = generateStoreResourceAction<types.IAnswer>(constants.STORE_ANSWER);
export const clearAnswer = generateClearResourceAction(constants.CLEAR_ANSWER);
